import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import {
    addEventAttribute,
    audienceButtons,
    changeAttribute,
    getAttribute,
    getBestImage,
    getImageWithPrefix,
    getLocalDate,
    hasAttribute,
    imagePad,
    inheritAudiences, isUrlValid,
    manageAttractionData, manageVenueData,
    MetaTags,
    relatedSchemaArtistCard,
    setAttribute,
    setRoomAttribute,
    setUniqueAttractionAttribute,
    setUniqueEventAttribute,
    smallEventCard,
    smallSchemaArtistCard,
    thumbnailPad,
    toastSuccess
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import metaDataLinks from "../../components/common/metaDataLinks";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {Dialog, Transition} from "@headlessui/react";
import {XMarkIcon} from "@heroicons/react/24/outline";
import FindAttractions from "./findAttractions";
import FindVenues from "../venues/findVenues";
import NLPPrompt from "../nlp/nlpprompt";
import {ToastContainer} from "react-toastify";
import MediaCollection from "../media/mediaCollection";
import EditDescriptions from "../../components/common/editdescriptions";
import {CountryDropdown, RegionDropdown, CountryRegionData} from 'react-country-region-selector';
import ArtistSources from "./sourcesArtist";
import {XCircleIcon} from "@heroicons/react/16/solid";
import ListActionItems from "../../components/actionitems/listActionItems";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ViewArtist() {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log(data);

    type SchemaAttraction = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const text = useRef("");
    const inFocus = useRef("");
    const [attractionData, setAttractionData] = useState<SchemaAttraction>();
    const [events, setEvents] = useState([]);
    const [relatedArtists, setRelatedArtists] = useState([]);
    const [photos, setPhotos] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [open, setOpen] = useState(false);
    const [showAI, setShowAI] = useState(false);
    const [showSources, setShowSources] = useState(false);
    const [showMediaSelector, setShowMediaSelector] = useState(false);
    const [attractionName, setAttractionName] = useState("");
    const [canEdit, setCanEdit] = useState(false);
    const [editRequests, setEditRequests] = useState([]);

    useEffect(() => {
        getEditability();
        getArtist();
        getEvents("");
        getRelatedArtists();
        getEditRequests();

    }, []);
    const now = new Date();

    const getArtist = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/api/artist.do?`, {

            tiny: true, artist: params.id, admin: true, ticket: localStorage.getItem('ticket'), bust: now.toUTCString()
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }

                   }).then(function (response) {
            // handle success
            //console.log(response.data);
            setAttractionData(response.data)
            setAttractionName(response.data.name);
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const toggleSources = () => {
        setShowSources(!showSources);
        setOpen(!open);
    }

    const getRelatedArtists = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/dynamic/relatedartists.do`, {

            tiny: true, artist: params.id, admin: true, ticket: localStorage.getItem('ticket'), bust: now.toUTCString()
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }

                   }).then(function (response) {
            // handle success
            //console.log(response.data);
            setRelatedArtists(response.data.collection)
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const propagateArtistAudiences = () => {
        toastSuccess('Propagating audiences');
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/performer/data/propagateaudience.do`, {

            tiny: true, artist: params.id, admin: true, ticket: localStorage.getItem('ticket')
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }

                   }).then(function (response) {
            // handle success
            //console.log(response.data);
            toastSuccess('Audiences propagated');
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const propagateArtistType = () => {
        toastSuccess('Propagating type');
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/performer/data/propagatetype.do`, {

            tiny: true, artist: params.id, admin: true, ticket: localStorage.getItem('ticket')
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }

                   }).then(function (response) {
            // handle success
            //console.log(response.data);
            toastSuccess('Type propagated');
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const getEditRequests = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/claimlist.do`, {
            ticket: localStorage.getItem('ticket'),
            artist: params.id,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data && response.data.length > 0)
            {
                setEditRequests(response.data);
            }

        });
    }

    const requestEdit = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/claim.do`, {
            ticket: localStorage.getItem('ticket'),
            artist: params.id,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data.success)
            {
                toastSuccess("Request sent");
            }

        });
    }

    const getEditability = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/canedit.do`, {
            ticket: localStorage.getItem('ticket'),
            artist: params.id,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data.canedit)
            {
                setCanEdit(true);
            }

        });
    }


    const handleImageURL = e => {
        var imageurl = e.target.value;
        if (imageurl.length > 4 && !isUrlValid(imageurl))
        {
            toastSuccess("URL is invalid");

            return;
        }
        console.log('handle imageurl: ', e.target.value);
        let key = "bestimage";
        let value = imageurl;
        let unique = true;
        let remove = false;
        let artistid = params.id;

        manageAttractionData(key, value, artistid);


        //console.log(text.current);
        //setAttribute(data['guid'], e.target.id, document.getElementById(e.target.id).textContent, true, false);
    };

    const handleEditPrivileges = (guid,email) => {


        setUniqueAttractionAttribute("requestEdit", guid, 'false', 'true', params.id);
        setUniqueAttractionAttribute(guid, email, 'false', 'true', params.id);
        setUniqueAttractionAttribute("canEdit", guid, 'false', 'false', params.id);

        toastSuccess('Attraction updated');
    }


    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            if (value === 'true')
            {
                toastSuccess('Event set to public');
            }
            else
            {
                toastSuccess('Event set to private');
            }

        }
        else if (button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            //viewEvent(null,eventid);
        }
        else if (button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Attraction Type set to ' + value);

        }

        else if (button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key, value, unique, eventid);

            toastSuccess('Attribute ' + key + ' set to ' + value);

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueAttractionAttribute('pgg.audience.' + key, 'pgg.audience.' + value, unique, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }
        else if (button === 'setDescription')
        {
            console.log('setting description');
            let key = "description-html-en";
            let value = e.target.dataset.description;
            let unique = true;
            let remove = false;
            let eventid = params.id;

            setUniqueAttractionAttribute(key, value, unique, remove, eventid);

            toastSuccess('Description set ' + key + ' Remove: ' + remove);

        }

        if (button === 'setArtistImage')
        {
            console.log('settingMedia');
            let media = e.target.dataset.media;
            let key = "bestimage";
            let value = e.target.dataset.media;
            let unique = true;
            let remove = false;
            let artistid = params.id;

            manageAttractionData(key, value, artistid);

            toastSuccess('Set photo');
            setAttractionData({...attractionData, image: media});
            setOpen(false);

        }

        if (button === 'inheritAudience')
        {
            console.log('settingMedia');
            let artistid = params.id;
            let inheritartist = e.target.dataset.inheritartist;
            inheritAudiences(artistid, null, inheritartist);

            toastSuccess('set audience');
        }
    }

    const changeName = e => {
        e.preventDefault();
        console.log(attractionName);
        manageAttractionData("name", attractionName, params.id);
        toastSuccess('Saved');
    }

    const setEmail = e => {
        e.preventDefault();
        console.log(e.target.email.value);
        setUniqueAttractionAttribute("email", e.target.email.value, true, false, params.id);
        toastSuccess('Saved');
    }

    const changeType = e => {
        //console.log(e.target.value);
        if (e.target.value)
        {
            manageAttractionData("artisttype", e.target.value, params.id);
        }
        toastSuccess('Saved');
    }

    const changeCountry = val => {
        //console.log(val);
        if (val)
        {
            manageAttractionData("country", val, params.id);
        }
        toastSuccess('Saved');
    }


    const getEvents = nextOffset => {
        axios.get(`${process.env.REACT_APP_CLOUDAPI_URL}/v1/eventadmin/events/artist/`+params.id, {
            params: {
                instance: 'promogogo', limit: 12, offset: nextOffset, artist: params.id, light: true,
            }

        }).then(function (response) {
            // handle success
            //console.log("events", response);
            setEvents(response.data.collection);
            if(response.data.pagination.nextOffset)
            {
                getEvents(response.data.pagination.nextOffset);
            }

        });
    }

    const showMedia = () => {
        setShowAI(false);
        setShowMediaSelector(true);
        setOpen(true);
    }

    const showAIprompt = () => {
        setShowAI(true);
        setShowMediaSelector(false);
        setOpen(true);
    }


    return (

        <div className="min-h-full">
            <MetaTags
                title={attractionData && attractionData.name}
                description='Au�velda�u menningarumfj�llunina'
                image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
                name='Team Mobilitus'
            />
            <SidebarNavigation/>

            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen lg:max-w-4xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div
                                                className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">
                                                            Action Panel
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-red-700 text-white hover:bg-red-500 hover:outline-none hover:ring-2 hobver:ring-red-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="relative mt-6 flex-1 px-4 sm:px-6"
                                                     onClick={event => clickedEvent(event)}>
                                                    {showSources && <ArtistSources/>}
                                                    {attractionData && showAI &&
                                                     <EditDescriptions theData={attractionData}
                                                                       artist={attractionData['@id']} venue={null}
                                                                       event={null}/>}
                                                    {attractionData && showMediaSelector &&
                                                     <MediaCollection wide={true} target={'setArtistImage'}/>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            <div className="lg:pl-72">

                <main>
                    {attractionData && <div className="grid sm:grid-cols-3 gap-4 overflow-hidden">
                        <div className="sm:col-span-2 sm:p-1">
                            <div className="mt-2">
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">

                                    <div className="mt-1 mb-2">
                                        {attractionData && <div className=" px-2 sm:mt-16 sm:px-0 lg:mt-0 overflow-hidden">
                                            {!canEdit && <div className="rounded-md bg-red-50 p-4">
                                                <div className="flex">
                                                    <div className="shrink-0">
                                                        <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
                                                    </div>
                                                    <div className="ml-3">
                                                        <h3 className="text-sm font-medium text-red-800">You do not have permission to edit this performer</h3>
                                                        <div className="mt-2 text-sm text-red-700">
                                                            <ul role="list" className="list-disc space-y-1 pl-5">
                                                                <li>Any changes you make will be ignored.</li>
                                                                <li>You can ask us for edit privileges. Please explain why.</li>
                                                            </ul>
                                                            <button type={'button'} className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                                    onClick={() => requestEdit()}>Request edit privileges</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}

                                            <div className="grid sm:grid-cols-3 gap-4">
                                                <div className="col-span-1" >
                                                <div onClick={() => showMedia()}>
                                                    {attractionData.image && imagePad(attractionData.image)}
                                                    {!attractionData.image &&
                                                     <div className="text-sm align-text-bottom">Upload Image</div>}
                                                </div>
                                                    <div>
                                                        <input type={'url'}
                                                               className={'block w-full rounded-none border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  tracking-tight text-gray-900'}
                                                               onBlur={handleImageURL}
                                                               defaultValue={attractionData.image}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-span-2">
                                                    <form onSubmit={changeName}>
                                                        <div className="mt-2 flex rounded-md shadow-sm w-11/12">
                                                            <div
                                                                    className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                <div
                                                                        className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                                                                </div>
                                                                <input
                                                                        type="text"
                                                                        name="value"
                                                                        id="value"
                                                                        className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  text-3xl font-bold tracking-tight text-gray-900"
                                                                        defaultValue={attractionName}
                                                                        onChange={event => setAttractionName(event.target.value)}
                                                                />
                                                            </div>
                                                            <button
                                                                    type="submit"
                                                                    className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                            >

                                                                Save
                                                            </button>
                                                        </div>

                                                    </form>
                                                    <div>
                                                        <form>
                                                            <select
                                                                    className="mt-4 block w-11/12 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                    defaultValue={attractionData && attractionData.gogo && attractionData.gogo.artistType && attractionData.gogo.artistType}
                                                                    onChange={(event) => changeType(event)}>

                                                                <option value={''}>Attraction type:</option>
                                                                <option value={'activism'}>activism</option>
                                                                <option value={'activities'}>activities</option>
                                                                <option value={'artist'}>artist</option>
                                                                <option value={'author'}>author</option>
                                                                <option value={'band'}>band</option>
                                                                <option value={'brand'}>brand</option>
                                                                <option value={'burlesque'}>burlesque</option>
                                                                <option value={'chef'}>chef</option>
                                                                <option value={'choir'}>choir</option>
                                                                <option value={'comedian'}>comedian</option>
                                                                <option value={'communitygroup'}>communitygroup</option>
                                                                <option value={'company'}>company</option>
                                                                <option value={'competition'}>competition</option>
                                                                <option value={'composer'}>composer</option>
                                                                <option value={'conductor'}>conductor</option>
                                                                <option value={'conference'}>conference</option>
                                                                <option value={'course'}>course</option>
                                                                <option value={'crafter'}>crafter</option>
                                                                <option value={'dancer'}>dancer</option>
                                                                <option value={'designer'}>designer</option>
                                                                <option value={'dj'}>dj</option>
                                                                <option value={'entertainer'}>entertainer</option>
                                                                <option value={'exercise'}>exercise</option>
                                                                <option value={'exhibition'}>exhibition</option>
                                                                <option value={'fanclub'}>fanclub</option>
                                                                <option value={'fashionhouse'}>fashionhouse</option>
                                                                <option value={'festival'}>festival</option>
                                                                <option value={'film'}>film</option>
                                                                <option value={'foodie'}>foodie</option>
                                                                <option value={'gaming'}>gaming</option>
                                                                <option value={'governmentinstitution'}>governmentinstitution</option>
                                                                <option value={'guide'}>guide</option>
                                                                <option value={'influencer'}>influencer</option>
                                                                <option value={'label'}>label</option>
                                                                <option value={'lecturer'}>lecturer</option>
                                                                <option value={'library'}>library</option>
                                                                <option value={'municipality'}>municipality</option>
                                                                <option value={'museum'}>museum</option>
                                                                <option value={'musician'}>musician</option>
                                                                <option value={'ngo'}>ngo</option>
                                                                <option value={'orchestra'}>orchestra</option>
                                                                <option value={'other'}>other</option>
                                                                <option value={'painter'}>painter</option>
                                                                <option value={'person'}>person</option>
                                                                <option value={'photographer'}>photographer</option>
                                                                <option value={'play'}>play</option>
                                                                <option value={'poet'}>poet</option>
                                                                <option value={'politicalparty'}>politicalparty</option>
                                                                <option value={'politician'}>politician</option>
                                                                <option value={'promoter'}>promoter</option>
                                                                <option value={'publisher'}>publisher</option>
                                                                <option value={'quizzes'}>quizzes</option>
                                                                <option value={'religious'}>religious</option>
                                                                <option value={'restaurant'}>restaurant</option>
                                                                <option value={'school'}>school</option>
                                                                <option value={'science'}>science</option>
                                                                <option value={'show'}>show</option>
                                                                <option value={'singer'}>singer</option>
                                                                <option value={'singersongwriter'}>singersongwriter</option>
                                                                <option value={'speaker'}>speaker</option>
                                                                <option value={'special'}>special</option>
                                                                <option value={'studentshowcase'}>studentshowcase</option>
                                                                <option value={'team'}>team</option>
                                                                <option value={'trainer'}>trainer</option>
                                                                <option value={'troupe'}>troupe</option>
                                                                <option value={'tv_show'}>tv_show</option>
                                                                <option value={'wellness'}>wellness</option>

                                                            </select>
                                                        </form>
                                                    </div>
                                                    <div className={'mt-1 text-sm text-gray-500 p-2'}>from</div>
                                                    <div>
                                                        <form>
                                                            <CountryDropdown
                                                                    classes={'mt-1 block w-11/12 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md'}
                                                                    showDefaultOption={true}
                                                                    valueType={'short'}
                                                                    value={attractionData && attractionData.address && attractionData.address.addressCountry && attractionData.address.addressCountry.toUpperCase()}
                                                                    onChange={(val) => changeCountry(val)}/>
                                                        </form>
                                                    </div>
                                                    <div className={'mt-2 '}>
                                                        <select
                                                                className={'block w-11/12 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md'}
                                                                defaultValue={attractionData && attractionData.gogo && attractionData.gogo.majorType && attractionData.gogo.majorType}
                                                                onChange={(event) => manageAttractionData("attractiontype", event.target.value, attractionData['@id'])}>
                                                            <option value={''}>Default event type</option>
                                                            <option value={'arts'}>Arts</option>
                                                            <option value={'artsandcrafts'}>Arts and Crafts</option>
                                                            <option value={'burlesque'}>Burlesque / Drag</option>
                                                            <option value={'charity'}>Charity</option>
                                                            <option value={'community'}>Community</option>
                                                            <option value={'communityEntertainment'}>Community
                                                                Entertainment
                                                            </option>
                                                            <option value={'conference'}>Conference</option>
                                                            <option value={'convention'}>Convention</option>
                                                            <option value={'educational'}>Educational</option>
                                                            <option value={'exercise'}>Exercise</option>
                                                            <option value={'exhibition'}>Exhibition</option>
                                                            <option value={'film'}>Film</option>
                                                            <option value={'foodspecials'}>Food specials</option>
                                                            <option value={'hospitality'}>Hospitality</option>
                                                            <option value={'karaoke'}>Karaoke</option>
                                                            <option value={'lecture'}>Lecture</option>
                                                            <option value={'localinterest'}>Local Interest</option>
                                                            <option value={'media'}>Media</option>
                                                            <option value={'meetup'}>Meetup</option>
                                                            <option value={'music'}>Music</option>
                                                            <option value={'nonprofit'}>Nonprofit organization</option>
                                                            <option value={'other'}>Other</option>
                                                            <option value={'outdoorsActivity'}>Outdoors Activity
                                                            </option>
                                                            <option value={'parking'}>Parking</option>
                                                            <option value={'party'}>Party</option>
                                                            <option value={'politics'}>Politics</option>
                                                            <option value={'publicService'}>Public Service</option>
                                                            <option value={'publishingparty'}>Publishing Party</option>
                                                            <option value={'quizzes'}>Quizzes</option>
                                                            <option value={'reading'}>Reading</option>
                                                            <option value={'religion'}>Religion</option>
                                                            <option value={'shopping'}>Shopping</option>
                                                            <option value={'sports'}>Sports</option>
                                                            <option value={'standup'}>Standup</option>
                                                            <option value={'theater'}>Theater</option>
                                                            <option value={'tourist'}>Tourist Attractions</option>
                                                            <option value={'unknown'}>unknown</option>
                                                            <option value={'upsell'}>Upsell</option>
                                                            <option value={'wellness'}>Wellness</option>
                                                            <option value={'workshop'}>Workshop</option>
                                                        </select>
                                                    </div>
                                                        <div className={'mt-2'}>
                                                            <form onSubmit={setEmail}>
                                                                <div className="mt-2 flex rounded-md shadow-sm w-11/12">
                                                                    <div
                                                                            className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                        <div
                                                                                className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                                                                        </div>
                                                                        <input
                                                                                type="text"
                                                                                name="email"
                                                                                id="email"
                                                                                className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 "
                                                                                defaultValue={attractionData && attractionData.internal && attractionData.internal.email}
                                                                                placeholder={'Email'}
                                                                                //onChange={event => setAttractionName(event.target.value)}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                            type="submit"
                                                                            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                    >

                                                                        Save
                                                                    </button>
                                                                </div>

                                                            </form>
                                                        </div>


                                                    {attractionData.description && (<>
                                                        <p className={'mt-2 p-2'}
                                                           dangerouslySetInnerHTML={{__html: attractionData.description}}></p>
                                                    </>)}
                                                </div>
                                            </div>
                                            {attractionData && <>
                                                <div className={'mt-4 isolate inline-flex rounded-md shadow-sm'}>
                                                    <button
                                                            className={'relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                            onClick={() => window.location.href = '/attraction/' + attractionData['@id'] + '/merge'}
                                                    >Merge

                                                    </button>

                                                    <button onClick={() => showAIprompt()}
                                                            className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>
                                                        Descriptions
                                                    </button>
                                                    <button onClick={() => toggleSources()}
                                                            className={'relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>
                                                        Sources
                                                    </button>
                                                </div>


                                            </>}
                                            <section aria-labelledby="details-heading" className="mt-12">
                                                {events && events.length > 0 &&
                                                 <h3 className={'text-2xl font-bold tracking-tight text-gray-900'}>Upcoming
                                                     events</h3>}
                                                <div>

                                                    <div
                                                            className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:grid-cols-2">
                                                        {events.map((event, index) => (<div key={event['@id']}>
                                                            {smallEventCard(event)}
                                                        </div>))}

                                                    </div>
                                                    <div className="px-4 sm:px-6 lg:px-8 mt-2">
                                                        <h3 className="text-md font-bold tracking-tight text-gray-900">Target
                                                            Audience</h3>

                                                        <div className="sm:flex sm:items-center">
                                                            <div className="sm:flex-auto"
                                                                 onClick={(e) => clickedEvent(e)}>
                                                                {attractionData && audienceButtons(attractionData)}
                                                            </div>
                                                            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">

                                                            </div>
                                                        </div>
                                                        <div className={'mt-2'}>
                                                            <button className={'relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                                    onClick={() => propagateArtistAudiences()}>Propagate
                                                                Audiences
                                                            </button> &nbsp;
                                                            <button className={'relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                                    onClick={() => propagateArtistType()}>Propagate Type
                                                            </button>
                                                        </div>
                                                        <div className={'mt-1'}>
                                                            {attractionData &&
                                                             <button className={'relative -ml-px inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                                     onClick={() => window.open(`${process.env.REACT_APP_API_URL}/go/adminartists.do#!/artist/` + attractionData['@id'], '_blank')}>Edit</button>}
                                                        </div>

                                                        {relatedArtists && relatedArtists.length > 0 && <>
                                                            <h5 className={'text-lg font-bold tracking-tight text-gray-900 mt-2'}>Related
                                                                Artists</h5>
                                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:grid-cols-2"
                                                                     onClick={(e) => clickedEvent(e)}
                                                                >
                                                                    {relatedArtists.map((artist, index) => (
                                                                        <div key={artist['@id']}>
                                                                            {relatedSchemaArtistCard(artist)}
                                                                        </div>))}
                                                                </div>

                                                            </>}

                                                        </div>

                                                    </div>
                                            </section>

                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sm:col-span-1 p-1">
                        <h1 className="text-2xl tracking-tight text-gray-500">Links</h1>
                            <div className="p-1">

                                {attractionData && metaDataLinks(attractionData)}


                            </div>
                            {data.isAdmin && <div className={'mt-2'}><ListActionItems eventid={null} artistid={attractionData['@id']} venueid={null}/></div>}
                            {data.isAdmin && editRequests && editRequests.length > 0 &&
                             <div className=" px-4 mt-4 sm:px-0 mr-2" onClick={(event) => clickedEvent(event)}>
                                 <h5 className={'text-gray-900 font-bold text-sm'}>Edit requests</h5>
                                 {editRequests.map((editRequest, index) => (<>
                                     {editRequest.key} {editRequest.value} <button type={'button'} className={'                                                                                    className="inline-flex items-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"\n'}
                                                                                   onClick={() => handleEditPrivileges(editRequest.key,editRequest.value)}>Accept</button>
                                 </>))}
                             </div>}
                        </div>
                    </div>}
                </main>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>

        </div>)
}
